<div>
    <mat-label *ngIf="label" class="subHeading">{{label}}</mat-label>
    <div class="form1">
        <p class="file-name">{{fileName}}</p>
        <input type="file" style="display: none" #fileInput (change)="onChange($event.target)" [accept]="validFormats"/>
        <button class="file-select-button" (click)="fileInput.click()">
            Choose file
        </button>
    </div>
</div>